export default __webpack_public_path__ + "static/media/2.02fd7526.png";